import type { BrowserPort } from "./types";

/** 웹: 새 탭(noopener). */
export const webBrowser: BrowserPort = {
  async open(url) {
    window.open(url, "_blank", "noopener,noreferrer");
  },
};
